import { render, staticRenderFns } from "./billing-addons.vue?vue&type=template&id=4c1d9e68"
import script from "./billing-addons.vue?vue&type=script&lang=js"
export * from "./billing-addons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports